import _implicitStylesheets from "./search.css";
import _implicitScopedStylesheets from "./search.scoped.css?scoped=true";
import _searchSwitcher from "search/switcher";
import _wdsChip from "wds/chip";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _aceFilterPanel from "ace/filterPanel";
import _wdsButton from "wds/button";
import _wdsSortOptions from "wds/sortOptions";
import _searchResults from "search/results";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h1 class="results-title${0}"${2}>${"t1"}</h1>`;
const $fragment2 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment3 = parseFragment`<p role="status" class="visually-hidden${0}"${2}>${"t1"}</p>`;
const $fragment4 = parseFragment`<p class="chips-title${0}" role="status" type-style="body-3"${2}>${"t1"}<span class="visually-hidden${0}"${2}>${"t3"}</span></p>`;
const $fragment5 = parseFragment`<div class="no-filter-state-container${0}"${2}><div class="img-no-filter-state${0}"${2}><img${"a2:src"}${"a2:alt"}${3}></div><span class="apply-filter${0}" data-testid="apply-filter"${2}>${"t4"}</span><p class="apply-filter-suggestion${0}"${2}>${"t6"}</p></div>`;
const stc0 = {
  classMap: {
    "page-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "search-title-container": true
  },
  key: 1
};
const stc2 = {
  "content-container": true
};
const stc3 = {
  classMap: {
    "filters": true
  },
  attrs: {
    "size": "4:12"
  },
  key: 6
};
const stc4 = {
  classMap: {
    "filter-chips": true,
    "mobile-filter-chips": true
  },
  key: 7
};
const stc5 = {
  "type": "filter"
};
const stc6 = {
  "close-button": true
};
const stc7 = {
  "data-testid": "closeButton"
};
const stc8 = {
  classMap: {
    "results-container": true
  },
  attrs: {
    "size": "12:12@x-small 8:12@large"
  },
  key: 15
};
const stc9 = {
  classMap: {
    "results-info-container": true
  },
  key: 16
};
const stc10 = {
  classMap: {
    "button-container": true
  },
  key: 17
};
const stc11 = {
  "add-filter-button": true
};
const stc12 = {
  "data-testid": "openFiltersButton"
};
const stc13 = {
  key: 22
};
const stc14 = {
  classMap: {
    "filter-chips": true
  },
  key: 25
};
const stc15 = {
  classMap: {
    "search-container": true
  },
  key: 31
};
const stc16 = {
  "isSearchPage": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, c: api_custom_element, h: api_element, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13} = $ctx;
  return [$cmp.flagsLoaded ? api_element("div", stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.searchTitle))]), api_custom_element("search-switcher", _searchSwitcher, {
    key: 4,
    on: {
      "searchtypechange": _m0 || ($ctx._m0 = api_bind($cmp.handleSwitch))
    }
  })]), api_element("div", {
    classMap: stc2,
    attrs: {
      "grid": "",
      "align-items": "spread",
      "gap": $cmp.contentGap
    },
    key: 5
  }, [$cmp.shouldDisplayFilters ? api_element("div", stc3, [$cmp.mobileFilterChips ? api_element("ul", stc4, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(8, filterChip.value)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc5,
      key: 9,
      on: {
        "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleFilterAnalytics))
      }
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 10,
      on: {
        "close": _m2 || ($ctx._m2 = api_bind($cmp.handleChipClosed))
      }
    })])]);
  })) : null, api_custom_element("ace-filter-panel", _aceFilterPanel, {
    props: {
      "options": $cmp.filterSections,
      "searchable": "true"
    },
    key: 11,
    on: {
      "filterchange": _m3 || ($ctx._m3 = api_bind($cmp.handleFilterSelectionChange)),
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleFilterAnalytics))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc7,
    props: {
      "variant": "secondary",
      "width": "fill",
      "name": "mobileFiltersButton",
      "label": $cmp.closeButtonText
    },
    key: 12,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.switchMobileFilterPanel))
    }
  })]) : null, $cmp.shouldDisplayFilters ? $cmp.mobileFilterPanel ? api_static_fragment($fragment2, 14, [api_static_part(0, {
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.switchMobileFilterPanel))
    }
  }, null)]) : null : null, api_element("div", stc8, [api_element("div", stc9, [api_element("div", stc10, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc11,
    attrs: stc12,
    props: {
      "variant": $cmp.buttonVariant,
      "ariaExpanded": $cmp.displayMobileFilterPanel,
      "name": "addFilters",
      "label": $cmp.addFilterButtonText
    },
    key: 18,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.switchMobileFilterPanel))
    }
  }), !$cmp.hideSortButton ? api_custom_element("wds-sort-options", _wdsSortOptions, {
    props: {
      "variant": $cmp.buttonVariant,
      "options": $cmp.sortOptions,
      "selectedOption": $cmp.selectedSortOption
    },
    key: 19,
    on: {
      "sortselectionchange": _m9 || ($ctx._m9 = api_bind($cmp.handleSortSelectionChange)),
      "analytics": _m10 || ($ctx._m10 = api_bind($cmp.handleSortAnalytics))
    }
  }) : null]), !$cmp.noFiltersNoKeyword ? !$cmp.searchError ? !$cmp.showFilterChips ? api_static_fragment($fragment3, 21, [api_static_part(1, null, api_dynamic_text($cmp.showingResultsLabel))]) : null : null : null, !$cmp.noFiltersNoKeyword ? !$cmp.searchError ? $cmp.showFilterChips ? api_element("div", stc13, [!$cmp.isLoading ? api_static_fragment($fragment4, 24, [api_static_part(1, null, api_dynamic_text($cmp.filterByLabel)), api_static_part(3, null, api_dynamic_text($cmp.filterByAria))]) : null, api_element("ul", stc14, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(26, filterChip.value)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc5,
      key: 27,
      on: {
        "analytics": _m11 || ($ctx._m11 = api_bind($cmp.handleFilterAnalytics))
      }
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 28,
      on: {
        "close": _m12 || ($ctx._m12 = api_bind($cmp.handleChipClosed))
      }
    })])]);
  }))]) : null : null : null]), $cmp.noFiltersNoKeyword ? api_static_fragment($fragment5, 30, [api_static_part(2, {
    attrs: {
      "src": $cmp.noFiltersAppliedImageUrl,
      "alt": $cmp.labels.error.applyFilter.altText
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.labels.error.applyFilter.title)), api_static_part(6, null, api_dynamic_text($cmp.labels.error.applyFilter.suggestion))]) : null, !$cmp.noFiltersNoKeyword ? api_element("div", stc15, [api_custom_element("search-results", _searchResults, {
    props: stc16,
    key: 32,
    on: {
      "searchtypechange": _m13 || ($ctx._m13 = api_bind($cmp.handleSwitch))
    }
  })]) : null])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-58cu3bbjnip";
tmpl.legacyStylesheetToken = "undefined-_search";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
